import React, { FC } from 'react';
import { useTranslationsContext } from '../../lib/translation';

type Props = {
  mailReceiptHelp: string;
  goBackLink: string;
}

const MailSentReceiptComponent: FC<Props> = ({ mailReceiptHelp, goBackLink }) => {
  const translations = useTranslationsContext();
  return (
    <div className="page__content__block">
      <div className="box theme--background-secondary">
        <div className="row row--equal-width-items">
          <div className="row__item">
            <h2 className="text--default-size text--pull">{translations.forgot.receipt.help}</h2>
            <p>{mailReceiptHelp}</p>
            <a className="a--text-link" href={goBackLink}>{translations.forgot.receipt.link}</a>
          </div>
          <div className="row__item">
            <h2 className="text--default-size text--pull">{translations.forgot.support.header}</h2>
            <a className="a--text-link" href={translations.forgot.support.student.link}>{translations.forgot.support.student.text}</a>
            <br />
            <a className="a--text-link" href={translations.forgot.support.staff.link}>{translations.forgot.support.staff.text}</a>
          </div>
        </div>
      </div>
    </div>
  );
};

MailSentReceiptComponent.displayName = 'MailSentReceiptComponent';
export default MailSentReceiptComponent;
